/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { FunctionComponent, memo } from 'react';
import { HeaderWrapper } from '../styled';
import { I_MenuPortfolio, I_Portfolio } from '../typesIndex';
import HeaderGeneral from './Header.General';

interface Props {
  user?: I_Portfolio['user'];
}

export interface I_UserProps {
  isHideSlug?: boolean;
  slug?: I_Portfolio['slug'];
  user?: I_Portfolio['user'];
}

export interface I_MenuProps {
  menu?: I_Portfolio['menu'];
  menuCollectionSelected: string;
  onChangeCollectionPortfolio: (
    type: I_MenuPortfolio['type'],
    value: string,
  ) => void;
}

export interface I_HeaderStyle4Component extends FunctionComponent<Props> {
  User: typeof User;
  Menu: typeof Menu;
}

function HeaderStyle4({ user }: Props) {
  return (
    <HeaderWrapper>
      <div className="portBanner headerStyle-4 d-block">
        <HeaderGeneral.Logo logo={user?.logo} home_page={user?.home_page} />
        <HeaderGeneral.Cover cover={user?.cover} />
      </div>
    </HeaderWrapper>
  );
}

function User({ slug, user, isHideSlug }: I_UserProps) {
  return (
    <div className="portInfo col-md-4">
      <div className="--content">
        <div className="portProfile d-flex align-items-center">
          <HeaderGeneral.UserInfo
            user={user}
            slug={slug}
            avatarClass="mb-3"
            wrapperClass="d-flex flex-column"
            isHideSlug={isHideSlug}
            childrenAboveBio={<HeaderGeneral.Socials isShowType user={user} />}
          />
        </div>
      </div>
    </div>
  );
}

function Menu(props: I_MenuProps) {
  return (
    <div className="portMenu d-flex align-items-baseline">
      <i className="fas fa-grid me-2" />
      <HeaderGeneral.Menu {...props} />
    </div>
  );
}

HeaderStyle4.User = memo(User);
HeaderStyle4.Menu = memo(Menu);

export default HeaderStyle4;
